import Shop from '../shop';

export default class MovieStudio extends Shop {
    /**
     *
     */
    constructor() {
        super({
            name:                 'Movie studio',
            id:                   'MovieStudio',
            coolDown:             1800,
            faClass:              'fa-film',
            individualCostFactor: 1.12,
            baseEarnings:         89579000.0,
            baseCosts:            179159040.0,
            grade:                8
        });
    }
}
